var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 30C59.5 13.7076 46.2924 0.5 30 0.5C13.7076 0.5 0.5 13.7076 0.5 30C0.5 46.2924 13.7076 59.5 30 59.5C46.2924 59.5 59.5 46.2924 59.5 30Z",
    fill: "white",
    stroke: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0529 21.1473C34.299 21.3934 34.4372 21.7272 34.4372 22.0752C34.4372 22.4232 34.299 22.757 34.0529 23.0031L27.556 29.5L34.0529 35.9969C34.292 36.2444 34.4243 36.576 34.4213 36.9201C34.4183 37.2642 34.2803 37.5934 34.0369 37.8368C33.7936 38.0801 33.4644 38.2181 33.1202 38.2211C32.7761 38.2241 32.4446 38.0918 32.197 37.8528L24.7722 30.4279C24.5262 30.1818 24.3879 29.848 24.3879 29.5C24.3879 29.152 24.5262 28.8182 24.7722 28.5721L32.197 21.1473C32.4432 20.9012 32.7769 20.763 33.125 20.763C33.473 20.763 33.8068 20.9012 34.0529 21.1473Z",
    fill: "#4987FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowButton);
export default __webpack_public_path__ + "static/media/carousel_arrow_button.1b477e56ee90ad2d20da43e7533b230f.svg";
export { ForwardRef as ReactComponent };